import validate from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/middleware/auth.global.ts";
import manifest_45route_45rule from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}